module.exports = {
    apiKey: "AIzaSyCW5EL0rDWYb7dWtq3-RDoNViHh38OTKaI",
    authDomain: "mid-pay.firebaseapp.com",
    projectId: "mid-pay",
    storageBucket: "mid-pay.appspot.com",
    messagingSenderId: "376377820205",
    appId: "1:376377820205:web:9c6c01e84245c273ac64a4",
    measurementId: "G-QY5K6RHF86"
};